// 服务器端存储服务 - 替代 IndexedDB，所有数据通过 HTTP API 存到服务器
// 需要管理员权限才能写入

import { adminAuth } from './adminAuth';

const API_BASE = '';

async function apiGet<T>(url: string): Promise<T | null> {
  try {
    const res = await fetch(`${API_BASE}${url}`);
    if (!res.ok) {
      if (res.status === 404) return null;
      console.warn(`API GET ${url} failed: ${res.status}`);
      return null;
    }
    return await res.json();
  } catch (e) {
    console.warn(`API GET ${url} error:`, e);
    return null;
  }
}

async function apiPost(url: string, data: any): Promise<void> {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'POST',
    headers: adminAuth.getAuthHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('登录已过期，请重新登录');
    }
    throw new Error(`API POST ${url} failed: ${res.status}`);
  }
}

async function apiPut(url: string, data: any): Promise<void> {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'PUT',
    headers: adminAuth.getAuthHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('登录已过期，请重新登录');
    }
    throw new Error(`API PUT ${url} failed: ${res.status}`);
  }
}

async function apiDelete(url: string): Promise<void> {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'DELETE',
    headers: adminAuth.getAuthHeaders(),
  });
  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('登录已过期，请重新登录');
    }
    throw new Error(`API DELETE ${url} failed: ${res.status}`);
  }
}

// 兼容层：提供与原来 IndexedDB 相同的 API
export const serverStorage = {
  // 获取单个数据项
  async getItem<T>(key: string, storeName: string): Promise<T | null> {
    return await apiGet<T>(`/api/data/${storeName}`);
  },

  // 保存单个数据项（整个 store 的数据）- 需要管理员权限
  async setItem<T>(key: string, storeName: string, value: T): Promise<void> {
    await apiPost(`/api/data/${storeName}`, value);
  },

  // 获取列表数据
  async getList<T>(storeName: string): Promise<T[]> {
    const data = await apiGet<any>(`/api/data/${storeName}`);
    if (data === null) return [];
    return Array.isArray(data) ? data : [];
  },

  // 保存列表数据（整个 store 的数据）- 需要管理员权限
  async saveList<T>(key: string, storeName: string, list: T[]): Promise<void> {
    await apiPost(`/api/data/${storeName}`, list);
  },

  // 删除数据（清空 store）- 需要管理员权限
  async removeItem(key: string, storeName: string): Promise<void> {
    await apiPost(`/api/data/${storeName}`, []);
  },
};

export default serverStorage;